import atom, {useAtom} from "utils/atom";
import {User} from "auth/types";

export const userAtom = atom<User | undefined | null>(null);

export const useAuthenticatedUser = () => {
  const user = useAtom(userAtom);
  if (!user) throw new Error("User not loaded yet");
  return user;
};
